export default {
	title: "Poziom Vip",
	current: "Obecny poziom VIP",
	status: {
		btn: ["Aktywowane", "Zarejestruj się teraz"]
	}
};
